import React, { useEffect, useRef } from 'react';
import Modal from 'react-modal';
import { reduxForm } from 'redux-form';
import { RiCloseLine } from 'react-icons/ri';
import TextField from '../shared/TextField';
import styles from './SetPassword.module.css';


let regexp = /^[а-я]+$/i;

const handleCheck = (e) => {
  if(regexp.test(e.key)) {
    e.preventDefault();
  }
}

const Line = ({ label, name }) => (
  <div className={styles.field}>
    <p className={styles.fieldLabel}>{label}</p>
    <TextField onKeyPress={e => handleCheck(e)} name={name} type="password" />
  </div>
);


function SetPassword(props) {
  const {
    isModalVisible,
    onRequestClose,
    oldpassword,
    newpassword,
    newpassword_repeat,
    doPasswordsMatch,
    passwordError,
    setPassword,
    setPasswordError,
  } = props;

  const prevPasswordError = useRef(passwordError);

  useEffect(() => {
    if (passwordError !== prevPasswordError.current) {
      prevPasswordError.current = passwordError;
      if (!passwordError || passwordError === 'success') {
        setPasswordError(null);
        onRequestClose();
      }
    }
  }, [passwordError]);

  const save = () => {
    if ((oldpassword && newpassword && newpassword_repeat) && doPasswordsMatch) {
      setPassword({ oldpassword, newpassword });
    }
  };

  const checkPassword = () => newpassword && newpassword_repeat;

  return (
    <Modal
      isOpen={isModalVisible}
      onRequestClose={onRequestClose}
      contentLabel="Modal"
      className={styles.modal}
      overlayClassName={styles.overlay}
    >
      <div className={styles.header}>
        <h3 className={styles.title}>Смена пароля</h3>
        <button className={styles.closeBtn} onClick={onRequestClose}>
          <RiCloseLine size={20} />
        </button>
      </div>

      <div className={styles.body}>
        {checkPassword() && !doPasswordsMatch && (
          <p className={styles.error}>Пароли не совпадают</p>
        )}

        {passwordError && passwordError !== 'success' && (
          <p className={styles.error}>{passwordError}</p>
        )}

        <Line label="Текущий пароль" name="oldpassword" />
        <Line label="Новый пароль" name="newpassword" />
        <Line label="Повторите новый пароль" name="newpassword_repeat" />

        <div className={styles.btns}>
          <button className={styles.btnCancel} onClick={onRequestClose}>
            Отмена
          </button>
          <button className={styles.btnSave} onClick={save}>
            Сменить
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default reduxForm({form: 'setPassword',})(SetPassword);
